import React from 'react';

const getViewBox = (name) => {
  switch (name) {
    case 'clock':
      return '0 0 512 512';
    case 'consult-now':
      return '0 0 102 60';
    default:
      return '0 0 32 32';
  }
};

const getPath = (name, props) => {
  switch (name) {
    case 'clock':
      return (
        <path
          {...props}
          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm57.1 350.1L224.9 294c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v137.7l63.5 46.2c5.4 3.9 6.5 11.4 2.6 16.8l-28.2 38.8c-3.9 5.3-11.4 6.5-16.8 2.6z"
        />
      );
    case 'consult-now':
      return (
        <g>
          <path
            {...props}
            d="M71.41,0.41C55.08,0.41,41.83,13.67,41.83,30s13.25,29.59,29.59,29.59S101,46.33,101,30S87.75,0.41,71.41,0.41
        		z M87.75,10.59l-4.28,4.28c-0.8,0.8-0.8,2.14,0,2.95c0.4,0.4,0.94,0.67,1.47,0.67s1.07-0.27,1.47-0.67l4.28-4.28
        		c3.35,3.88,5.49,8.84,5.89,14.32h-6.02c-1.2,0-2.14,0.94-2.14,2.14c0,1.2,0.94,2.14,2.14,2.14h6.02
        		c-0.4,5.35-2.54,10.31-5.89,14.32l-4.28-4.28c-0.8-0.8-2.14-0.8-2.95,0s-0.8,2.14,0,2.95l4.28,4.28
        		c-3.88,3.35-8.84,5.49-14.32,5.89v-6.02c0-1.2-0.94-2.14-2.14-2.14s-2.14,0.94-2.14,2.14v6.02c-5.35-0.4-10.31-2.54-14.32-5.89
        		l4.28-4.28c0.8-0.8,0.8-2.14,0-2.95c-0.8-0.8-2.14-0.8-2.95,0l-4.28,4.28c-3.35-3.88-5.49-8.84-5.89-14.32h6.16
        		c1.2,0,2.14-0.94,2.14-2.14c0-1.2-0.94-2.14-2.14-2.14h-6.02c0.4-5.35,2.54-10.31,5.89-14.32l4.28,4.28
        		c0.4,0.4,0.94,0.67,1.47,0.67s1.07-0.27,1.47-0.67c0.8-0.8,0.8-2.14,0-2.95l-4.28-4.28c4.42-3.75,10.17-6.02,16.33-6.02
        		C77.44,4.56,83.33,6.84,87.75,10.59z"
          />
          <path
            {...props}
            d="M71.41,34.15c1.47,0,2.81-0.8,3.48-2.01h7.23c1.2,0,2.14-0.94,2.14-2.14c0-1.2-0.94-2.14-2.14-2.14H74.9
        		c-0.4-0.54-0.8-1.07-1.34-1.34V10.99c0-1.2-0.94-2.14-2.14-2.14s-2.14,0.94-2.14,2.14v15.53c-1.2,0.67-2.01,2.01-2.01,3.48
        		C67.27,32.28,69.14,34.15,71.41,34.15z"
          />
          <path
            {...props}
            d="M35,37.76H16.93c-1.2,0-2.14,0.94-2.14,2.14s0.94,2.14,2.14,2.14H35c1.2,0,2.14-0.94,2.14-2.14
        		C37.14,38.7,36.07,37.76,35,37.76z"
          />
          <path
            {...props}
            d="M3.14,32.14h30.12c1.2,0,2.14-0.94,2.14-2.14c0-1.2-0.94-2.14-2.14-2.14H3.14C1.94,27.86,1,28.8,1,30
        		S1.94,32.14,3.14,32.14z"
          />
          <path
            {...props}
            d="M35,18.09H12.91c-1.2,0-2.14,0.94-2.14,2.14c0,1.2,0.94,2.14,2.14,2.14H35c1.2,0,2.14-0.94,2.14-2.14
        		C37.14,19.02,36.07,18.09,35,18.09z"
          />
        </g>
      );
    default:
      return <path />;
  }
};

const SVGIcon = ({
  name = '',
  style = {},
  SVGprops = { fill: '#000' },
  viewBox = '',
  width = '100%',
  className = '',
  height = '100%',
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox || getViewBox(name)}
  >
    {getPath(name, SVGprops)}
  </svg>
);

export default SVGIcon;
